export enum InvoiceAction {
  Created = 'Created',
  Paid = 'Paid',
  Issued = 'Issued',
  WrittenOff = 'written-off',
  Cancelled = 'cancelled',
  TransactionAdded = 'TransactionAdded',
}

export class StatusChange<T extends string> {
  constructor(
    private _before?: T,
    private _after?: T
  ) {}

  hasChanged(): boolean {
    return this._before !== this._after;
  }

  is(status: T): boolean {
    return this._after === status;
  }

  was(status: T): boolean {
    return this._before === status;
  }

  changedTo(status: T): boolean {
    return this.hasChanged() && this.is(status);
  }

  changedFrom(status: T): boolean {
    return this.hasChanged() && this.was(status);
  }

  changedFromOrTo(status: T): boolean {
    return this.changedFrom(status) || this.changedTo(status);
  }

  created(): boolean {
    return this._before === undefined;
  }

  deleted(): boolean {
    return this._after === undefined;
  }
}
